// extracted by mini-css-extract-plugin
export default {"myPhoto":"photo_myPhoto_YU9Yc"};